import { VtmnIcon, VtmnTooltip } from '@vtmn/react';
import clsx from 'clsx';
import { format, isPast } from 'date-fns';
import { useTranslation } from 'react-i18next';
import './dateCellTable.scss';

type DateCellTableProps = {
  date: string;
  extremumDate: string;
};

export const DateCellTable = ({ date, extremumDate }: DateCellTableProps) => {
  const { t } = useTranslation();

  const formatDate = Date.parse(date);

  return (
    <div
      data-testid={`date-cell_table_${extremumDate}`}
      className="date-cell_table_container"
    >
      <span className={clsx(isPast(formatDate) && 'no-editable')}>
        {format(new Date(date), 'dd/MM/yyyy')}
      </span>
      {isPast(formatDate) && (
        <div className="date-cell_table_icon">
          <VtmnTooltip position="top-left" tooltip={t('date_in_past')}>
            <VtmnIcon size={16} value="error-warning-line" />
          </VtmnTooltip>
        </div>
      )}
    </div>
  );
};
